module.exports = __webpack_public_path__ + "static/media/Chrome.c4ffddab.svg";